<template>
  <div class="tax-info-container" >
    <!-- 加载成功 -->
    <template v-if="isloading == 2">
      <Progress progress="64"></Progress>
      <!-- 头部标题 -->
      <div class="header">{{ taxList.length >= 2 ? $t('taxInformation.t000001') : $t('taxInformation.t000002') }}</div>

      <!-- 税务卡片列表 -->
      <div class="tax-list">
        <div v-for="(item, index) in taxList" :key="index" class="tax-item">
          <!-- 固有数据 -->
          <template v-if="!item.isNew">
            <!-- <div class="card" @click="modifyRegion(index)" :class="{'noBgColor': pageChange == 1 }">
              <span class="label">{{ $t('taxInformation.t000003')  }}</span>
              <span class="value">{{ item.tax_area || $t('taxInformation.t000004')  }}</span>
            </div>
            <div class="error-message oneOfAKind" v-if="!item.tax_area && showError">{{ $t('taxInformation.t000009')  }}</div> -->

            <div class="ipt-box notAvailable" @click="modifyRegion(index)" :class="{error: !item.tax_area && showError, noBgColor: pageChange == 1 || process_id == 3}">
              <div class="ipt-main" >
                <div class="val-box">
                <span class="label" :class="{ placeholder: !item.tax_area }"
                >{{ $t('taxInformation.t000003') }}</span
                >
                  <span class="val" v-if="item.tax_area">{{ item.tax_area || $t('taxInformation.t000004')  }}</span>
                </div>
                <span class="icon-arrow"></span>
              </div>
              <p class="error">{{ $t('taxInformation.t000009') }}</p>
            </div>


            <!-- <div class="card" :class="{ focus: inputFocusId == 1 }">
              <span class="label" v-if="inputFocusId == 1 || item.tax_no">{{ $t('taxInformation.t000005')  }}</span>
              <input class="input" v-model="item.tax_no" :placeholder="$t('taxInformation.t000006') " />
            </div>
            <div class="error-message" v-if="!item.tax_no && showError">{{ $t('taxInformation.t000010')  }}</div> -->

            <div class="ipt-box" :class="{error: !item.tax_no && showError, focus: inputFocusId == 5}">
              <div class="ipt-main">
                <div class="val-box" >
                  <span class="label" v-if="inputFocusId == 5 || item.tax_no">{{ $t('taxInformation.t000005') }}</span>
                  <Field
                    class="val"
                    v-model="item.tax_no"
                    :placeholder="inputFocusId == 5 ? '' : $t('taxInformation.t000005')"
                    @focus="inputFocus(5)"
                    @blur="inputBlur"
                  ></Field>
                </div>
              </div>
              <p class="error">{{ $t('taxInformation.t000010') }}</p>
            </div>
            <div class="upload-box" v-if="index > 0">
              <UploadImg
                :img="item.url"
                @afterRead="afterRead($event, index)"
                @del="delImg(index)"
                :quality="0.5"
                :text="$t('openInstitutionServices.g000026')"
              />
            </div>
          </template>
          <!-- 新增数据 -->
          <template v-else>
            <div class="newCard">
              <div class="handle">
                <div class="left">{{ $t('taxInformation.t000007')  }}</div>
                <div class="right"  @click.stop="deleteCard(index)">{{ $t('taxInformation.t000008')  }}</div>
              </div>

              <div class="ipt-box new" @click="chooseArea(index)" :class="{error: !item.tax_area && showError, noBgColor: pageChange == 1}">
                <div class="ipt-main" >
                  <div class="val-box">
                  <span class="label" :class="{ placeholder: !item.tax_area }"
                  >{{ $t('taxInformation.t000003') }}</span
                  >
                    <span class="val" v-if="item.tax_area">{{ item.tax_area || $t('taxInformation.t000004')  }}</span>
                  </div>
                  <span class="icon-arrow"></span>
                </div>
                <p class="error">{{ $t('taxInformation.t000009') }}</p>
              </div>

              <div class="ipt-box new" :class="{error: !item.tax_no && showError, focus: inputFocusId == 3}">
                <div class="ipt-main">
                  <div class="val-box" >
                    <span class="label" v-if="inputFocusId == 3 || item.tax_no">{{ $t('taxInformation.t000005') }}</span>
                    <Field
                      class="val"
                      v-model="item.tax_no"
                      :placeholder="inputFocusId == 3 ? '' : $t('taxInformation.t000005')"
                      @focus="inputFocus(3)"
                      @click="inputFocus(3)"
                      @blur="inputBlur"
                    ></Field>
                  </div>
                </div>
                <p class="error">{{ $t('taxInformation.t000010') }}</p>
              </div>
              <div class="upload-box" v-if="index > 0">
                <UploadImg
                  :img="item.url"
                  @afterRead="afterRead($event, index)"
                  @del="delImg(index)"
                  :quality="0.5"
                  :text="$t('openInstitutionServices.g000026')"
                />
              </div>
            </div>
          </template>
        </div>
        <!-- 添加按钮 -->
        <div v-if="taxList.length < 2" class="add-card" @click="addCard">
          <!-- <van-icon name="plus" :color="bgColor == 'black-theme' ? '#FFFFFF':'#333333'" /> -->
          <img v-if="bgColor == 'white-theme'" class="icon" src="../../../assets/images/id-card-upload-add.png" >
          <img v-else class="icon" src="../../../assets/images/open-account/Group 1726@3x.png" >
          <span>{{ $t('taxInformation.t000011')  }}</span>
        </div>
      </div>
      <!-- 按钮组 -->
      <nav-buttons
        navigationType="back"
        :next-text="$route.query.change == 1 ? $t('openAccount.t000094') : $t('openAccount.t000095')"
        :disabled="nextDis"
        @on-next="nextStep"
      />
    </template>
    <!-- 加载中 -->
    <template v-else-if="isloading == 1">
      <div class="loading">
        <Loading size="24px" type="spinner" vertical>{{ $t("common.loading_text") }}</Loading>
      </div>
    </template>

    <!-- 地区选择弹窗 -->
    <van-popup v-model="showAreaSelector" position="right" :style="{ width: '100%', height: '100%' }">
      <div class="popup-container">
        <div class="dialog-head">
          <a class="btn-back" @click="showAreaSelector = false"></a>
          <p class="dialog-title">{{ $t('taxInformation.t000012')  }}</p>
        </div>
        <div class="tips">{{ $t('taxInformation.t000015') }}</div>
        <div class="search-header">
          <van-search v-model="searchValue" :placeholder="$t('taxInformation.t000013') " shape="round" background="#fff" />
          <div class="btn" >{{ $t('taxInformation.t000016') }}</div>
        </div>

        <div class="index-list">
          <!-- 搜索无结果显示 -->
          <div v-if="searchValue && !hasSearchResult" class="empty-result">
            <van-empty :description="$t('taxInformation.t000014') " />
          </div>

          <!-- 有数据时显示列表 -->
          <template v-else>
            <div class="area-list">
              <van-cell v-for="item in filteredAreaList" 
                :key="item.id" 
                :title="item.name"
                @click="selectArea(item)" 
              />
            </div>
          </template>
        </div>

      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Button,
  Icon,
  Popup,
  Cell,
  Search,
  Field,
  Loading,
  Empty,
  Toast
} from "vant";
import navButtons from '../components/navButtons.vue'
import Progress from '../components/Progress.vue'
import UploadImg from "@/views/open-account/components/UploadImg.vue";

export default {
  name: "TaxInfo",
  components: {
    UploadImg,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [Search.name]: Search,
    [Empty.name]: Empty,
    Field,
    navButtons,
    Progress,
    Loading
  },
  data() {
    return {
      process_id: 1,    // 开户类型
      taxList: [],
      selectedIndex: -1,
      showAreaSelector: false,
      areaList: [],
      searchValue: "",
      showError: false,   // 错误显示控制标记
      pageChange: 0,
      isloading: 1, // 1 加载中 || 2加载成功
      inputFocusId: -1
    };
  },

  computed: {
    nextDis(){
      
      
      return this.taxList.length <= 0 || this.taxList.filter((e, i) => e.isNew && (!e.img_url || !e.tax_area_id || !e.tax_no)).length > 0
    },
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    // 判断是否有搜索结果
    hasSearchResult() {
      return this.searchValue
        ? this.filteredAreaList.some(item => item.name.toLowerCase().includes(this.searchValue.toLowerCase()) || (item.tel && item.tel.includes(this.searchValue)))
        : true;
    },
    // 搜索过滤后的列表
    filteredAreaList() {
      if (!this.searchValue) {
        return this.areaList;
      }
      // 过滤地区列表，匹配搜索关键词
      return this.areaList.filter(
        (item) =>
          item.name
            .toLowerCase()
            .includes(this.searchValue.toLowerCase()) ||
            item.tel && item.tel.includes(this.searchValue)
      );
    }
  },

  created() {
    this.init();
  },

  methods: {
    afterRead(res,index) {
      this.$set(this.taxList, index, {
        ...this.taxList[index],
        url: res.url, // 显示的
        img_url: res.content, // 提交的
      })
      this.$nextTick(()=>{
        this.$forceUpdate()
      })
    },
    delImg(index) {
      this.$set(this.taxList, index, {
        ...this.taxList[index],
        url: '', // 显示的
        img_url: '', // 提交的
      })
      const params = JSON.parse(JSON.stringify(this.taxList)).map(item => {
        item.url = '';
        return item;
      });
      this.$forceUpdate()
      // 通知服务端删除照片 不然下一次还是这个图的
      this.$apis.supplementSaveApi({ process_id: this.process_id, step_code: 9, step_order: 9, config_data: { tax_resident: params } });
    },
    async init() {
      this.getRouteParams();
      await this.getRegion();
      this.fetchTaxList();
    },
    // 获取接口数据 -》用户信息、税务列表
    async fetchTaxList() {
      try {
        const response = await this.$apis.accountSituationV2({ step_code: '1,3-2,9' });
        this.handleProcessId(response);                                // 获取第一步的process_id
        const userInfo = this.extractUserInfo(response);            // 提取用户信息
        this.taxList = this.buildTaxList(response, userInfo);     // 构建税务列表
        this.modifyFailure();
        this.isloading = 2;
      } catch (error) {
        this.isloading = 2;
        
      }
    },
    handleProcessId(response) {
      this.process_id = response?.process_info[1]?.process_id  || response?.get_open_account_info?.open_status;
    },
    // 提取默认的用户信息
    extractUserInfo(response) {
      const defaultUserInfo = { tax_area_id: '', tax_no: '', tax_area: '' };

      if (response?.process_info?.['3-2']?.config_data) {
        // 解析 JSON 数据
        const configData32 = JSON.parse(response.process_info['3-2'].config_data || '{}');
        let nationality_name = configData32.nationality_name || '';
        if ( configData32.nationality_code ) {
          nationality_name = this.areaList?.find( item => item.id == configData32.nationality_code)?.name;
        }
        // 提取用户信息
        return {
          tax_area_id: configData32.nationality_code || '',
          tax_no: configData32.id_card || '',
          tax_area: nationality_name || ''
        };
      }

      return defaultUserInfo;
    },
    // 构建税务列表
    buildTaxList(response, userInfo) {
      const defaultTaxList = [];

      if (response?.process_info?.[9]?.config_data) {
        const configData9 = JSON.parse(response.process_info[9].config_data || '[]');
        
        // 检查 configData9 是否有 list 和 tax_no
        if (Array.isArray(configData9.tax_resident)) {
          return configData9.tax_resident;
        }
      }

      // 如果 process_info[9].config_data 不存在，检查用户信息是否有有效值
      if (Object.keys(userInfo).some(key => userInfo[key])) {
        // 如果有有效值，将用户信息添加到默认税务列表
        defaultTaxList.push(userInfo);
      }
      // 返回默认税务列表
      return defaultTaxList;
    },
    // 获取路由参数
    getRouteParams() {
      this.pageChange = this.$route.query.change || 0
    },
    // 审核失败修改
    modifyFailure() {
      if ( this.pageChange == 1 && this.taxList.length <= 0 ) {
        this.taxList.push({
          tax_area_id: '',
          tax_no: '',
          tax_area: ''
        })
      }
    },
    modifyRegion(index) {
      if ( this.pageChange == 1 || this.process_id == 3 ) {
        this.chooseArea(index);
      }
    },
    // 打开地区选择
    async chooseArea(index) {
      this.selectedIndex = index;
      this.showAreaSelector = true;
    },
    async getRegion() {
      try {
        const result = await this.$apis.getAllCountryList();
        this.areaList = result;
      } catch (error) {
        
      }
    },
    deleteCard(index) {
      this.showError = false;
      this.taxList.splice(index, 1);
    },

    addCard() {
      this.taxList.push({ tax_area: "", tax_no: "", tax_area_id: "", isNew: true });
    },

    onClose() {
      this.showAreaSelector = false;
    },

    async nextStep() {
      this.showError = true;  // 点击下一步时设置显示错误提示
      if(this.nextDis) return
      // 检查是否所有必填项都已填写
      const isValid = this.taxList.every(item => item.tax_area && item.tax_no);

      if (isValid) {
        const loading = Toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: "spinner",
          message: this.$t("common.loading_text")
        });
        await this.reportData();
        let path = "/open-account/w8benPage";
        if(this.$route.query.change == 1){
          path = "/open-account/home";
        }
        this.$router
            .push(path)
            .finally(() => {
              loading.clear();
            });
      }
    },
    inputFocus(id){
      this.inputFocusId = id;
      setTimeout(() => {
        const element = document.activeElement;
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    },
    inputBlur(){
      this.inputFocusId = null;
      window.scrollTo(0, 0);
    },
    selectArea(item) {
      if ( Object.keys(item).length ) {
        const _index = this.taxList.findIndex(e => e.tax_area_id == item.id);
        if(_index >= 0){
          if(_index == this.selectedIndex){
            this.onClose();
          }else{
            Toast({
              message: this.$t('openAccount.t000176', {address: item.name}),
              className: "toast-top"
            });
          }
        }else{
          this.taxList[this.selectedIndex].tax_area = item.name;
          this.taxList[this.selectedIndex].tax_area_id = item.id;
          this.onClose();
        }
      }
    },
    // 上报数据
    async reportData() {
      const params = JSON.parse(JSON.stringify(this.taxList)).map(item => {
        item.url = '';
        return item;
      });
      await this.$apis.supplementSaveApi({ process_id: this.process_id, step_code: 9, step_order: 9, config_data: { tax_resident: params } });
    }
  },
  beforeDestroy() {
    // this.reportData();
  }
};
</script>

<style lang="less" scoped>
.tax-info-container {
  padding: 62px 32px 200px;
  min-height: 100vh;
  background-color: white;
  box-sizing: border-box;
  z-index: 1000;
  .header {
    font-size: 28px;
    color: #17161c;
    height: 88px;
    padding: 14px 0px;
    display: flex;
    align-items: center;
  }

  .tax-list {
    margin-bottom: 80px;
  }

  .tax-item {
    margin-bottom: 30px;
    .card {
      // height: 132px;
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      padding: 20px 32px;
      box-sizing: border-box;
      position: relative;
      &.noBgColor {
        background: transparent !important;
        .value {
          color: #b9b9b9;
        }

      }
      &:after{
        content: '';
        position: absolute;
        margin-top: -1px;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        border: 1px solid rgba(23, 22, 28, 0.25);
        transform: scale(0.5);
        border-radius: 20px;
      }
      .label {
        font-size: 24px;
        line-height: 24px;
        padding: 4px 0 20px;
        color: #747377;
        transform: translate3d(0,0,0);
            animation: labelAni .2s .1s linear both;
      }
      @keyframes labelAni{
        0%{
          font-size: 28px;
        }
        100%{
          font-size: 24px;
        }
      }
      .value {
        font-size: 32px;
        line-height: 32px;
        color: #b9b9b9;
      }
      .input {
        background: white;
        border: none;
        color: #17161C !important;
        z-index: 99;
        line-height: 32px;
        font-weight: 500;
      }
      .input::placeholder {
        font-size: 28px;
        color: #747377;
        font-weight: normal;
      }
      &:first-child {
        margin-bottom: 24px;
        background: #f9fafc;
      }

    }
    .newCard {
      margin-top: 52px;
      border: 2px dashed rgba(23,22,28,0.45);
      border-radius: 8px;
      .handle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 24px 24px 20px;
        .left {
          color: #17161c;
          font-size: 32px;
          font-weight: 500;
        }
        .right {
          color: #FD2626;
          font-size: 28px;
        }
      }
      .card {
        margin: 24px 24px 20px;
        &.selectArea {
          display: flex;
          flex-direction: row;
          align-items: center;
          .left {
            display: flex;
            flex-direction: column;
            flex: 1;
            .value {
              color: #17161C;
              font-weight: 500;
            }
          }
        }
      }
      .error-message {
        margin: -16px 24px 10px;
      }
    }
    .error-message {
      color: #fd2626;
      font-size: 24px;
      margin-top: 6px;
      &.oneOfAKind {
        margin-top: -18px;
      }
    }
  }

  .add-card {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 56px;
    color: #000000;
    font-size: 32px;
    .icon {
      width: 56px;
      height: 56px;
      margin-right: 20px;
      color: #666;
    }
  }

  .loading {
    margin-top: 200px;
  }
}

.popup-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  position: relative;
  z-index: 1000;
  .dialog-head {
    height: 100px;
    display: flex;
    padding: 0 100px;
    background: #fff;
    z-index: 10;
    position: relative;
    .btn-back {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
      background: url("../../../assets/images/arrow-right.png") no-repeat center;
      background-size: 48px 48px;
      transform: rotateY(180deg);
    }
    .dialog-title {
      flex: 1;
      text-align: center;
      font-size: 32px;
      color: #17161c;
      line-height: 100px;
    }
  }
  .tips {
    padding: 32px 32px 0px;
    font-size: 32px;
    font-weight: bold;
    color: #17161c;
    background: #fff;
    z-index: 99;
  }
  .search-header {
    position: sticky;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    padding: 0px 16px;
    background: #fff;
    // border-bottom: 1px solid #eee;

    .van-search {
      flex: 1;
      margin-right: 10px;
    }
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 88px;
      height: 100%;
      font-size: 32px;
    }
    .van-cell {
      min-height: 64px !important;
    }
  }

  .index-list {
    flex: 1;
    overflow-y: auto;
  }

  .empty-result {
    padding-top: 100px;
  }
}
.upload-box{
  margin: 0 24px 24px;
}
.ipt-box {
  margin-bottom: 24px;
  &.noBgColor {
    background: transparent !important;
    .value {
      color: #b9b9b9;
    }
    .icon-arrow {
      display: block !important;
    }
  }
  &.new {
    margin: 24px 24px 20px;
  }
  &.notAvailable {
    background: #F9FAFC;
    .val {
      color: #B9B9B9 !important;
    }
    .icon-arrow {
      display: none;
    }
  }
  &.disabledBg {
    background: #F9FAFC;
    /deep/ .van-cell {
      background: #F9FAFC;
    }
  }
  &.focus{
    .ipt-main{
      &:after{
        border-color: #17161C;
      }
      ::v-deep .van-cell{
        input {
          &::placeholder {
            font-size: 0;
          }
        }
      }
    }
  }
  &.error{
    .ipt-main {
      &:after {
        border-color: #FD2626;
      }
    }
  }
  .ipt-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    min-height: 56px;
    position: relative;
    &:after{
      content: '';
      position: absolute;
      margin-top: -1px;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      border: 1px solid rgba(23, 22, 28, 0.25);
      transform: scale(0.5);
      border-radius: 20px;
    }
    .val-box {
      position: relative;
      z-index: 3;
      flex: 1;
      display: flex;
      flex-direction: column;
      line-height: 1;
      font-size: 32px;
      @keyframes labelAni{
        0%{
          font-size: 28px;
        }
        100%{
          font-size: 24px;
        }
      }
      .label {
        color: #747377;
        padding: 4px 0 20px;
        font-size: 24px;
        animation: labelAni .2s .1s linear both;
        &.placeholder {
          padding: 12px 0 6px 0;
          font-size: 28px;
          animation: none;
        }
      }
      ::v-deep .van-cell {
        min-height: 0px;
        font-size: 32px;
        line-height: 32px;
        input{
          &::placeholder {
            font-size: 28px;
            color: #747377;
            font-weight: normal;
          }
          &:focus ~ .van-field__body{
            background: red;
          }
        }
        textarea {
          font-size: 32px;
          line-height: 35px;
          min-height: 70px;
          color: #17161c;
        }
      }
      .val {
        padding: 0;
        line-height: 36px;
        color: #17161c;
        font-weight: 500;
      }
    }
    .icon-arrow {
      width: 32px;
      height: 32px;
      background: url("../../../assets/images/arrow-down.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .error {
    display: none;
    margin-top: 12px;
    color: #fd2626;
    font-size: 24px;
    &.show{
      display: block;
    }
    &.right{
      text-align: right;
    }
  }
  &.error{
    .ipt-main{
      border-color: #fd2626;
    }
    .error{
      display: block;
    }
  }
}
.black-theme {
  .tax-info-container {
    background: #1B1C24 !important;
    .header {
      color: white;
    }
    .tax-item {
      .newCard {
        border-color: white;
      }
      .card {
        background: transparent !important;
        .input {
          background: transparent;
          color: #9D9D9F !important;
        }
        &:after{
          border-color: rgba(255,255,255,0.25);
        }
      }
      .left {
        color: white !important;
        .value {
          color: white !important;
        }
      }
    }
    .add-card {
      color: white;
    }
    .ipt-box{
      &.notAvailable {
        background: #14151D;
        /deep/ .van-cell {
          background: #14151D;
        }
        .val {
          color: #c8c9cc !important;
        }
      }
      &.focus{
        .ipt-main{
          &:after{
            border-color: rgba(255,255,255,0.25);
          }
        }
      }
      &.error{
        .ipt-main{
          &:after{
            border-color: #fd2626;
          }
        }
      }
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,0.25);
        }
        .label{
          color: #9D9D9F;
        }
        .icon-arrow{
          background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
          width: 32px;
          height: 32px;
          background-size: 100% 100%;
        }
        .val{
          color: #fff;
          ::v-deep{
            .van-cell__value input::placeholder {
              color: #9D9D9F !important;
            }
            textarea{
              color: #fff;
            }
          }
        }
      }
    }
    .popup-container {
      background: #1B1C24 !important;
      .dialog-head {
        background: #1B1C24 !important;
      }
      .tips {
        background: #1B1C24 !important;
      }
      .search-header {
        background: #1B1C24 !important;
        .van-search {
          background: #1B1C24 !important;
        }
        .btn {
          color: white;
        }
      }
      /deep/ .van-cell__title {
        color: white;
      }
      /deep/ .van-field__control {
        color: #17161C;
      }
    }
  }

  /deep/ .van-popup {
    z-index: 99999 !important;
  }

  .area-list {
    flex: 1;
    overflow-y: auto;
  }
}

// /deep/ .van-field__body {
//   input {
//     color:#17161C;
//   }
// }
</style>
